import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { Lock } from 'lucide-react';
import logoMark from '../assets/hardwall-logo.webp';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useContext(AuthContext);
  const { t } = useLanguage();
  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  setLoading(true);

  try {
    // ✅ CORRECTO: dos parámetros separados, no un objeto
    const result = await login(email, password);
    
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.message ? t(result.message) : t('Login failed'));
    }
  } catch (error) {
    console.error('Login error:', error);
    setError(error.message || t('Login failed. Please check your credentials.'));
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-language">
          <LanguageSwitcher compact />
        </div>
        <div className="login-header">
          <img className="login-logo" src={logoMark} alt="" width="112" height="112" />
          <h1>Hardwall Security</h1>
          <p>{t('Management System')}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="login-error" role="alert">{error}</div>}
          
          <div>
            {/* the e-mail, or the username (a guard's employee code) */}
            <label className="field-label" htmlFor="login-email">{t('Email or username')}</label>
            <input
              id="login-email"
              className="input"
              type="text"
              autoComplete="username"
              autoCapitalize="none"
              spellCheck="false"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('your.email@hardwallsecurity.com or your employee code')}
              required
            />
          </div>

          <div>
            <label className="field-label" htmlFor="login-password">{t('Password')}</label>
            <input
              id="login-password"
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('Enter your password')}
              required
            />
          </div>

          <button 
            type="submit" 
            className="btn btn--primary"
            disabled={loading}
          >
            {loading ? t('Signing in...') : t('Sign In')}
          </button>
        </form>

        <div className="login-footer">
          <Lock aria-hidden="true" />
          <p>{t('Secure Access Only')}</p>
        </div>
      </div>
    </div>
  );
};

export default Login;